export const getMetaDescription = (brandName: string, ipoName: string) => {
  return `Find ${getName(brandName, ipoName)} IPO Listing Date, Price, Lot Size, Timeline & more. Start Investing in ${ipoName} IPO Online with Upstox Today.`;
};

export const getMetaTitle = (brandName: string, ipoName: string) => {
  return `${getName(brandName, ipoName)} IPO - Find Opening Date, Price, Lot Size - Upstox`;
};

const getName = (brandName: string, ipoName: string) => {
  const ipoArr = ipoName.split('-');

  if(ipoArr.length>1){
    return `${ipoArr[0].trim()} ${brandName}`;
  }

  return brandName;  
}
